/**
 * Arabic for the Approvals board on the platform's approval chain (build 4):
 * the shell's notices when a request is raised, a step signed or an order
 * issued, and the board's own new text — who is signing, the steps the
 * platform gives them, whose step a request waits on — which i18n/dom.ts
 * translates inside the board and the shared sheet. Proposed; pending native
 * review.
 *
 * "Step" is خطوة; "sign" a step is يعتمد; a request is طلب; the purchase
 * order is أمر الشراء.
 */
const ar: Record<string, string> = {
  /* the shell's notices (demo/platform/writes/approvals.ts) */
  "{ref} raised on the platform. It now waits on Engineering.":
    "رُفع الطلب {ref} على المنصة. وهو الآن بانتظار الهندسة.",
  "{ref} rejected at {step}.": "رُفض الطلب {ref} في خطوة {step}.",
  "{ref} approved at every step. The purchase order can now be issued.":
    "اعتُمد الطلب {ref} في جميع الخطوات. يمكن الآن إصدار أمر الشراء.",
  "{ref} approved at {step}, above that step's limit. The steps after it will see that.":
    "اعتُمد الطلب {ref} في خطوة {step} بما يتجاوز حدّها. ستطّلع الخطوات التالية على ذلك.",
  "{ref} approved at {step}. It moves to the next step.": "اعتُمد الطلب {ref} في خطوة {step}. ينتقل إلى الخطوة التالية.",
  "Purchase order {po} issued for {ref}.": "صدر أمر الشراء {po} للطلب {ref}.",

  /* the board (generated.ts, approvals view) */
  "Signing as": "التوقيع باسم",
  "Raising a request needs stores:write.": "رفع طلب يتطلب صلاحية stores:write.",
  "The lit steps are the ones the platform gives you.": "الخطوات المضاءة هي التي تمنحك إياها المنصة.",
  "The platform gives you no step of the chain.": "لا تمنحك المنصة أي خطوة في سلسلة الاعتماد.",
  "Reading the approval chain…": "جارٍ قراءة سلسلة الاعتماد…",
  "The platform did not open the approval chain to you.": "لم تفتح المنصة سلسلة الاعتماد لك.",
  "Could not read the approval chain. This is what was last read.":
    "تعذّرت قراءة سلسلة الاعتماد. هذا ما قُرئ آخر مرة.",
  "Nothing is waiting on you right now.": "لا شيء بانتظارك الآن.",
  "Waiting on": "بانتظار",
  "Waiting on someone else": "بانتظار شخص آخر",
  "Stores requisitions are decided on the Store & Warehouse screen. Waiting there:":
    "تُقرَّر طلبات المخازن في شاشة المخازن والمستودع. بانتظار القرار هناك:",
  "Issued by someone who holds stores:approve.": "يُصدره من يحمل صلاحية stores:approve.",
  "No approvals are recorded on the platform yet.": "لم تُسجَّل أي اعتمادات على المنصة بعد.",
  "Each step is signed by the person signed in. The platform records who and when.":
    "يعتمد كلَّ خطوة الشخصُ الذي سجّل دخوله، وتسجّل المنصة من اعتمدها ومتى.",
};

export default ar;
